import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import axios from '../../axios'
import Alert from 'react-s-alert'
import CustomModal from '../../components/CustomModal'
import qs from 'qs'
import Paging from '../../components/Paging'
import { MEDIA_HOST } from '../../constants/siteConfig'
import FormDropdown from '../../components/FormDropdown';
import DropdownView from "./DropdownView";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";

import {
  Badge
} from "reactstrap";
import ModalHelp from "../../components/ModalHelp";
import moment from "moment";

class Lists extends Component {

    constructor() {
        super();
        this.state = {
            dataTugas    : [],
            dataKelas : [],
            dataMapel : [],
            dataGuru : [],
            user_id : "",
            kelas_id : "",
            mapel_id : "",
            sortby : "",
            judul_tugas : "",
            pageCount    : 0,
            currentPage  : 0,
            isLoading    : false,
            isModalShow  : false,
            pageFrom     : 1,
            tutorial: '',
            isModalHelpShow  : false,
            sortName : '',
            sortOrder : '',
            startNo : 1,
        }
        this.toggleModal              = this.toggleModal.bind(this)
        this.handleChange               = this.handleChange.bind(this)
        this.handleSubmitDeleteButton = this.handleSubmitDeleteButton.bind(this)
        this.handlePageClick            = this.handlePageClick.bind(this)
        this.toggleModalHelp                = this.toggleModalHelp.bind(this)

    }

    toggleModal() {
        this.setState({ isModalShow: ! this.state.isModalShow })
    }

    toggleModalHelp() {

        this.setState({tutorial : 'https://www.youtube.com/embed/LIWzt8bYu5Q'})

        this.setState({ isModalHelpShow: ! this.state.isModalHelpShow })
    }

    handleSubmitDeleteButton() {
        this.setState({ isButtonLoading: true, modalShow: true });

		const url = '/tugas/delete'

		let newState = {
			user_id:localStorage.SISMART_USER_ID,
			tugas_id:this.state.tugas_id
		};

		axios({
			method: "post",
			url: url,
			data: qs.stringify(newState)
		})

		.then(response => {
			const result = response.data;

			if (result.success) {
				Alert.success(result.message);
                this.toggleModal();
                this.loadData();
                window.location.reload();
			} else {
				if (Array.isArray(result.message)) {
					result.text.map(item => {
						Alert.error(item);

						return true;
					});
				} else {
					Alert.error(result.message);
				}

				this.setState({ isButtonLoading: false });
			}
		})
		
		.catch(error => {
			console.log(error);
			this.setState({ isButtonLoading: false });
			Alert.error("Gagal terhubung ke server!");
		});

		this.setState({ modalShow: false });
    }

    handlePageClick(data) {

        let selected = data.selected; // zero based index

        this.setState({ currentPage: selected }, () => {
            this.loadData();
        });
    }

    loadDataKelas(){
        axios.post("/kelas")
            .then(response => {
                return response.data.data.map(item => ({
                    key : item.kelas_id,
                    value : item.kelas_nama
                }))
            })
            .then(result => {
                this.setState({
                    dataKelas: result,
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    loadDataMapel(){
        axios.post("/mapel")
        .then(response => {
            return response.data.mapelexport.map(item => ({
                key: item.mapel_id,
                value : item.mapel_nama
            }))
        })
        .then(result => {
            this.setState({
                dataMapel: result
            })
        })
        .catch(error => {
            console.log("Mapel Undefinded")
        })
    }

    handleChange(event) {
        
        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name] : value,
        })
      
    }

    loadDataGuru(){
        
        axios.post("/user?level=guru")
        .then(response => {
            return response.data.data.map(item => ({
                key: item.user_id,
                value : item.user_nama
            }))
        })
        .then(result => {
            this.setState({
                dataGuru : result
            })
        })
        .catch(error => {
            console.log("Guru Undefinded")
        })
    }

    loadData() {

        this.setState({ isLoading: true })

        const params = qs.stringify({
            page: this.state.currentPage + 1,
            locale:"id",
            platform:"web",
            kelas : this.state.kelas_id,
            mapel : this.state.mapel_id,
            sortby : this.state.sortby,
            judul_tugas : this.state.judul_tugas,
            user : this.state.user_id,
            sortName : this.state.sortName === '' ? 'tugas_id' : this.state.sortName,
            sortOrder : this.state.sortOrder === '' ? 'desc' : this.state.sortOrder,
        })

        axios({
            method: 'post',
            url: '/tugas/all?' + params
        })
        .then((response) => {

            const result = response.data
            if (result.success === true) {
                if (this.state.sortOrder === "") {
                    result.data.data.sort((a, b) => (a.tugas_id > b.tugas_id ? -1 : 1))
                }
                console.log(result.data.data)
                this.setState({
                    dataTugas: result.data.data,
                    pageCount: result.data.last_page,
                    pageFrom: result.data.from,
                    isLoading: false,
                    sortName : this.state.sortName,
                    sortOrder : this.state.sortOrder,
                })
            }else {
           
                Alert.error(result.message,{
                    position: 'bottom-right',
                })
                this.setState({ dataTugas:[],isLoading: false })
            }      
        })
        .catch((error) => {
            console.log(error)
            this.setState({ isLoading: false })
            Alert.error("Gagal terhubung ke server!",{
                position: 'bottom-right',
            })
        })
    }

    componentDidMount() {
        
		if(localStorage.SISMART_USER_LEVEL !=='administrator'){
			this.props.history.replace("/dashboard");
        }
        
        this.loadDataKelas();
        this.loadDataMapel();
        this.loadDataGuru();
        this.loadData()        
    }

    componentDidUpdate(prevProps, prevState) {

        if (prevState.kelas_id !== this.state.kelas_id || 
            prevState.mapel_id !== this.state.mapel_id ||
            prevState.judul_tugas !== this.state.judul_tugas ||
            prevState.sortby !== this.state.sortby ||
            prevState.user_id !== this.state.user_id ||
            prevState.sortName !== this.state.sortName ||
            prevState.sortOrder !== this.state.sortOrder) {
            this.loadData()
        }
    }

    onSortChange(sortName, sortOrder) {
        this.setState({
            sortName,
            sortOrder
        });
    }

    formatOpsi(cell, row, enumObject, index){
        const url = this.props.match.url;
        return (
            <div>
                <NavLink to={`${url}/detail/${row.tugas_id}`} className="btn btn-secondary btn-sm" >
                    Detail
                </NavLink>
                <NavLink to={`${url}/edit/${row.tugas_id}`} className="btn btn-secondary btn-sm" style={{margin:'5px'}}>
                    Edit
                </NavLink>
                <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => {
                        this.toggleModal();
                        this.setState({ tugas_id: row.tugas_id });
                    }}
                >
                    Hapus
                </button>
            </div>
        )
    }

    render () {
        const strt = this.state.startNo;
        const url = this.props.match.url;

        function indexN(cell, row, enumObject, index){
            return (<div>{index+strt}</div>)
        }

        function formatNama(cell, row, enumObject, index){
            return (
                <div>
                    {row.tugas_judul}
                    <div style={{marginTop:'10px'}}>
                        <Badge color={'primary'} style={{padding:'5px'}}>{row.user_nama}</Badge>
                        <br/>
                        <Badge color={'primary'} style={{padding:'5px'}}>{row.kelas_nama}</Badge>
                        <br/>
                        <Badge color={'primary'} style={{padding:'5px'}}>{row.mapel_nama}</Badge>
                    </div>
                </div>
            );
        }

        function formatStatus(cell, row, enumObject, index){
            return row.tugas_status === "1" ? "Aktif" : "Non Aktif";
        }

        const options = {
            clearSearch: true,
            searchPosition: 'left',
            sortName : this.state.sortName,
            sortOrder : this.state.sortOrder,
            onSortChange : this.onSortChange.bind(this)
        }

        return (         
            <div className="col-sm-12">

                <ModalHelp
                    isShow={this.state.isModalHelpShow}
                    toggleModal={this.toggleModalHelp}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Tutorial Penggunaan Fitur"
                    modalBodyText={this.state.tutorial}
                    modalSubmitText="Ya" />

                <CustomModal
                    isShow={this.state.isModalShow}
                    toggleModal={this.toggleModal}
                    handleSubmit={this.handleSubmitDeleteButton}
                    modalHeaderText="Hapus Data"
                    modalBodyText="Anda yakin ingin menghapus data ini?"
                    modalSubmitText="Ya" />

                <div className="card">
                    <div className="card-block">
                        <NavLink 
                            to={`${this.props.match.url}/add`} 
                            className="btn btn-primary"
                        >
                            Tambah Tugas Baru
                        </NavLink>
                    </div>
                </div>
                <div className="card">
                    <div className="card-header">
                        Data Tugas Siswa

                        <button
                            type="button"
                            title='Tutorial'
                            className="btn btn-danger btn-sm"
                            style={{ float: 'right'}}
                            onClick={() => {
                                this.toggleModalHelp();
                                // this.setState({ tutorial: levelName});
                            }}
                        >
                            <i className="fa fa-question-circle"s></i>
                        </button>

                    </div>
                        <div className="card-block">
                         <div className="form-group row">
                            <div className="col-md-3">
                                <FormDropdown
                                    items = {this.state.dataGuru}
                                    onChange = {this.handleChange}
                                    value={this.state.user_id.toString()}
                                    placeholder={"Pilih Guru"}
                                    name="user_id"
                                />
                            </div>

                            <div className="col-md-3">
                                <FormDropdown
                                    items={this.state.dataKelas}
                                    onChange={this.handleChange}
                                    value={this.state.kelas_id.toString()}
                                    placeholder={"Pilih Kelas"}
                                    name="kelas_id"
                                />
                            </div>

                            <div className="col-md-3">
                                <FormDropdown
                                    items = {this.state.dataMapel}
                                    onChange = {this.handleChange}
                                    value={this.state.mapel_id.toString()}
                                    placeholder={"Pilih Mapel"}
                                    name="mapel_id"
                                />
                            </div>

                             <div className="col-md-3">
                                 <input
                                     name="judul_tugas"
                                     type="text"
                                     className="form-control"
                                     placeholder="Ketikkan Judul Tugas ..."
                                     value={this.state.judul_tugas}
                                     onChange={this.handleChange}
                                 />
                             </div>

                        </div>
                        <hr/>
                        {
                            this.state.isLoading ? "Memuat Data..." : (
                                this.state.dataTugas !== null && this.state.dataTugas.length === 0 ? "Data Kosong..." : (
                                    <div className="div-table-sismart-sekolah">
                                        <BootstrapTable data={this.state.dataTugas} striped hover remote options={options}>
                                            <TableHeaderColumn width='30' dataField="any" dataAlign='center' dataFormat={indexN} isKey>No</TableHeaderColumn>
                                            <TableHeaderColumn width='200' tdStyle={{wordBreak: "break-all"}} dataField="tugas_judul" headerAlign="center" dataFormat={formatNama}>Judul</TableHeaderColumn>
                                            <TableHeaderColumn width='100' dataAlign='center' dataField="tugas_create_date" dataSort>Tanggal Pembuatan</TableHeaderColumn>
                                            <TableHeaderColumn width='100' dataAlign='center' dataField="tugas_due_date" dataSort>Batas Pengumpulan</TableHeaderColumn>
                                            {/* <TableHeaderColumn width='100' dataField="tugas_desc">Deskripsi</TableHeaderColumn> */}
                                            <TableHeaderColumn width='50' dataAlign='center' dataField="tugas_status" dataFormat={formatStatus} dataSort>Status</TableHeaderColumn>
                                            <TableHeaderColumn width='100' dataAlign='center' dataField="any" dataFormat={this.formatOpsi.bind(this)}>Opsi</TableHeaderColumn>
                                        </BootstrapTable>
                                        <hr/>
                                        <Paging
                                            handlePageClick={this.handlePageClick}
                                            pageCount={this.state.pageCount}
                                            currentPage={this.state.currentPage}
                                        />
                                    </div>
                                )
                            )
                        }
                    </div>
                </div>
            </div>                   
        )
    }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/Tugas/Lists.js